import * as Yup from 'yup';

export const cancelRidesValidationSchema = Yup.object().shape({
  cancellationReasonKey: Yup.string().required('Please select a cancel reason'),
});
